import React, { useEffect, useState } from 'react';
import { Settings2, Loader2, Send, Save } from 'lucide-react';
import { api } from '../context/AuthContext';

const TAGE = ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag'];
const feld = 'text-xs border border-gray-200 px-2 py-1.5 bg-white focus:border-[#b8893d] focus:outline-none';

export const BerichtEinstellungen = ({ toast }) => {
  const [cfg, setCfg] = useState(null);
  const [empf, setEmpf] = useState('');
  const [busy, setBusy] = useState('');
  useEffect(() => {
    api.get('/admin/einstellungen/zugang-bericht').then((r) => { setCfg(r.data); setEmpf(r.data.empfaenger.join(', ')); }).catch(() => {});
  }, []);
  if (!cfg) return null;
  const run = async (art, fn) => {
    setBusy(art);
    try { await fn(); } catch (e) { toast({ title: 'Fehler', description: e?.response?.data?.detail || 'Aktion fehlgeschlagen', variant: 'destructive' }); }
    finally { setBusy(''); }
  };
  const speichern = () => run('save', async () => {
    const { data } = await api.put('/admin/einstellungen/zugang-bericht', { ...cfg, empfaenger: empf.split(/[,;\s]+/).filter(Boolean) });
    setCfg(data); setEmpf(data.empfaenger.join(', '));
    toast({ title: 'Gespeichert', description: `Bericht jeden ${TAGE[data.wochentag]} um ${String(data.stunde).padStart(2, '0')}:00` });
  });
  const testen = () => run('test', async () => {
    const { data } = await api.post('/admin/einstellungen/zugang-bericht/test', {}, { timeout: 60000 });
    toast({ title: data.mail_sent ? 'Testbericht gesendet' : 'Nicht gesendet', description: data.mail_sent ? `An ${(data.empfaenger || []).join(', ')}` : (data.error || 'Mailversand nicht konfiguriert'), variant: data.mail_sent ? undefined : 'destructive' });
  });
  return (
    <div className="flex flex-wrap items-end gap-3 px-5 py-3 border-b border-gray-100 bg-[#fbfcfd]" data-testid="bericht-einstellungen">
      <div className="flex items-center gap-1.5 text-[10px] tracking-[0.2em] text-[#7a8a99] uppercase w-full md:w-auto md:self-center"><Settings2 className="w-3.5 h-3.5 text-[#b8893d]" /> Zugangs-Wochenbericht</div>
      <label className="flex flex-col gap-1 text-[10px] text-[#7a8a99] flex-1 min-w-[220px]">EMPFÄNGER (Komma-getrennt; nur Admin-Adressen werden beliefert, sonst alle Admins)
        <input value={empf} onChange={(e) => setEmpf(e.target.value)} className={feld} data-testid="bericht-empfaenger" />
      </label>
      <label className="flex flex-col gap-1 text-[10px] text-[#7a8a99]">WOCHENTAG
        <select value={cfg.wochentag} onChange={(e) => setCfg({ ...cfg, wochentag: Number(e.target.value) })} className={feld} data-testid="bericht-wochentag">
          {TAGE.map((t, i) => <option key={t} value={i} label={t} />)}
        </select>
      </label>
      <label className="flex flex-col gap-1 text-[10px] text-[#7a8a99]">UHRZEIT
        <select value={cfg.stunde} onChange={(e) => setCfg({ ...cfg, stunde: Number(e.target.value) })} className={feld} data-testid="bericht-stunde">
          {Array.from({ length: 24 }, (_, h) => <option key={h} value={h} label={`${String(h).padStart(2, '0')}:00`} />)}
        </select>
      </label>
      <button type="button" onClick={speichern} disabled={!!busy} className="inline-flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-sm bg-[#1B3A5C] text-white hover:bg-[#15304d] disabled:opacity-50" data-testid="bericht-speichern">
        {busy === 'save' ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Save className="w-3.5 h-3.5" />} Speichern
      </button>
      <button type="button" onClick={testen} disabled={!!busy} className="inline-flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-sm border border-[#b8893d] text-[#1B3A5C] hover:bg-[#fbf7f0] disabled:opacity-50" data-testid="bericht-test">
        {busy === 'test' ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Send className="w-3.5 h-3.5" />} Jetzt testweise senden
      </button>
    </div>
  );
};
